module.exports = __webpack_public_path__ + "img/edit.8b77fc3e.svg";